import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useIntl } from "react-intl";
import moment from "moment";

import Card from "../../UI/Card/Card";
import Button from "../../UI/Button/Button";
import EmptyState from "../../UI/State/EmptyState";
import * as Utils from "../../Utils/BillingUtils";

import * as InvoicesActions from "../../../middleware/Store/Actions/InvoicesActions";

import styles from "./Billing.module.scss";
import { faDownload, faReceipt } from "@fortawesome/free-solid-svg-icons";

import LogService from "../../../middleware/CommonSdk/LogService";
const LOG_TAG = "INVOICES";

const Invoices = (props) => {

    const intl = useIntl();
    const title = intl.messages.invoicesTitle;
    const subtitle = intl.messages.invoicesSubTitle;

    const [currency, setCurrency] = useState("");
    const [selectedInvoiceId, setSelectedInvoiceId] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        LogService.trace(LOG_TAG, "useEffect");
        if (props.account && props.account.data && props.account.data.billingAndPayment) {
            setCurrency(props.account.data.billingAndPayment.currency);
        }
    }, [props.account]);

    useEffect(() => {
        setLoading(true);
        if (props.user) {
            props.getListOfInvoices(props.user.id)
                .then(() => {
                    setLoading(false)
                })
        }
    }, [])

    let getFileId = invoice => {
        const body = invoice.body;

        const invoiceFile = invoice.invoiceFiles.find(item => {
            return body.includes(item.id);
        });

        if (invoiceFile) {
            return invoiceFile.id;
        }
        return null;
    };

    let invoices;
    if (props.invoices && props.invoices.length > 0) {
        invoices = props.invoices.map(invoice => (
            <tr id={`billingInvoices-item-${invoice.id}`} key={`invoice-${invoice.id}`}>

                <td id={`billingInvoices-item-${invoice.id}-date`} className={styles.gridLabel} >
                    {intl.formatDate(invoice.invoiceDate, { year: "numeric", month: "short", day: "numeric" })}
                </td>

                <td id={`billingInvoices-item-${invoice.id}-amount`} className={styles.gridLabel}>
                    {(currency.length > 1) ?
                        intl.formatNumber(invoice.amount, { style: "currency", currency: currency }) :
                        invoice.amount + " " + currency
                    }
                </td>

                <td id={`billingInvoices-item-${invoice.id}-link`}>
                    <span>
                        <Button
                            targetName="#downloadInvoiceFile"
                            data-id={`${invoice.id}`}
                            icon={faDownload}
                            className="btn-grid ml-1"
                            spinner={props.progress && (invoice.id === selectedInvoiceId)}
                            tooltipTitle={"Download the invoice file"}
                            onClick={(event) => {
                                setSelectedInvoiceId(invoice.id)
                                onDownloadInvoice(event, getFileId(invoice))
                                }
                            }
                        />
                    </span>
                </td>
            </tr>
        ))
    }

    const onDownloadInvoice = (event, fileId) => {
        LogService.info(LOG_TAG, "Want to download invoice file", fileId);

        if (fileId) {
            event.preventDefault();

            let callback = function (blob) {
                if (blob) {
                    const url = window.URL.createObjectURL(new Blob([blob]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute('download', "invoice-" + fileId + ".pdf");

                    // Append to html link element page
                    document.body.appendChild(link);

                    // Start download
                    link.click();

                    // Clean up and remove the link
                    link.parentNode.removeChild(link);
                } else {
                    LogService.info(LOG_TAG, "onDownloadInvoice", "invoice can't be downloaded");
                }
            };

            props.downloadInvoice(props.user.id, fileId, callback, this)
        }
    }

    return (
        <Card title={title} subtitle={subtitle} >
            <div className="row">
                <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    {props.hasInvoices && !loading && (<>
                        <div className="panel bg-fog mb-3">{intl.messages.invoicesMessage}</div>
                        <div id="invoices-list" className={styles.gridBody}>
                            <div className="table-responsive">
                                <table className="table">
                                    <tbody>
                                        {invoices}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </>)}

                    {(!props.hasInvoices || loading) && (
                        <div id="invoices-list-empty">
                            <EmptyState 
                                icon={faReceipt} 
                                text={intl.messages.invoicesNoReceiveInvoices}
                                progress={loading}
                            />
                        </div>
                    )}
                </div>
            </div>
        </Card>
    )
}

const mapStateToProps = state => {
    let getOfficialInvoices = invoices => {

        let val = invoices.filter(invoice => {
            return invoice.status === "Posted";
        });

        function compare(a, b) {
            if (moment(a.invoiceDate).isBefore(moment(b.invoiceDate))) return 1;
            if (moment(a.invoiceDate).isAfter(moment(b.invoiceDate))) return -1;
            return 0;
        }

        return val.sort(compare);
    };

    return {
        user: state.contacts.user,
        account: state.invoices.account,
        hasInvoices: Utils.hasInvoicesReceipt(state.invoices),
        invoices: getOfficialInvoices(state.invoices.invoices),
        invoice: state.invoices.invoice,
        progress: state.invoices.downloadInvoiceFileProgress,

    };
};

const mapDispatchToProps = dispatch => {
    return {
        downloadInvoice: (userId, fileId, callback) => dispatch(InvoicesActions.downloadInvoice(userId, fileId, callback)),
        getListOfInvoices: (userId) => dispatch(InvoicesActions.getListOfInvoices(userId))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Invoices);